module.exports = {"id":"187688","name":"Ganso","rating":"78","photo":"./data/images/photos/4/187688.png","club":{"name":"Séville FC","logo":"./data/images/clubs/SevilleFC.png"},"positions":["MOC","MC","MG","ATT"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Ganso0.json
// module id = 1528
// module chunks = 0